import Vue from 'vue';
import 'mutationobserver-shim';
import '@/registerServiceWorker';
import '@/plugins/bootstrap-vue';
import '@/plugins/vue-lazyload';
import '@/plugins/vee-validation';
import '@/plugins/vue-report-generators';
import App from '@/app/app.vue';
import router from '@/routers/router';
import store from '@/store';
import { appConfigAPI } from '@/providers/apis/app/app-config';
import { appConfigService } from '@/providers/services/app/app-config';
import { authService } from '@/providers/services/auth/auth';
import i18n from '@/i18n';
import './filters/filters';
import './filters/date';
import Permissions from '@/permission/permission';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import '@/plugins/multiselect-dropdown';
import { authAPI } from './providers/apis/auth/auth';
import { sessionService } from '@/providers/services/auth/session';

Vue.prototype.$access = Permissions;

Vue.config.productionTip = false;

(async () => {
  // Have to wait until the config loaded
  await appConfigAPI.getAppConfiguration().then((appConfig) => {
    appConfigService.setAppConfig(appConfig);
  });

  // Help to identify the access_token from the query params
  const urlParams = new URLSearchParams(document.location.search);
  const accessToken = urlParams.get('access_token');
  const session = sessionService.getSession();
  const nonce = urlParams.get('nonce');
  if (urlParams.get('am') === 'st' || !session && !nonce) {
    const token = await authAPI.getServerToken();
    const queryParams: any = {};
    for (const key of urlParams.keys()) {
      if (key !== 'am') {
        queryParams[key] = urlParams.get(key);
      }
    }
    if (token && token.accessToken) {
      const tokenKey = 'access_token';
      queryParams[tokenKey] = token.accessToken;
      await authService.loginBasedOnAccessToken(queryParams);
    }
  } else if (accessToken) {
    const queryParams: any = {};
    for (const key of urlParams.keys()) {
      queryParams[key] = urlParams.get(key);
    }
    await authService.loginBasedOnAccessToken(queryParams);
  }


  const application = {
    router,
    store,
    i18n,
    beforeCreate() {
      authService.checkAuthentication();
    },
    render: (h: any) => h(App),
  };

  new Vue(application).$mount('#mission-control');
})();

